import { camelCase } from "change-case";

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      sessionStorage.getItem('data') != null
        ? JSON.parse(sessionStorage.getItem('data'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      sessionStorage.setItem('data', JSON.stringify(user));
    } else {
      sessionStorage.removeItem('data');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const deleteCurrentUser = () => {
  try {
    sessionStorage.removeItem('data');
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : deleteCurrentUser -> error', error);
  }
};


export function convertKeysToCamelCase(obj) {
  const newObj = {};
  for (const key of Object.keys(obj)) {
    const camelCaseKey = camelCase(key);
    newObj[camelCaseKey] = obj[key];
  }
  return newObj;
}
